import { Input } from 'aos-ds'
import {
    translateParts,
    translatePartsOptional,
} from 'aos-helpers/src/helpers/translations/Translations'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TaskFormField } from '../../TaskFormField'

interface TaskTextFieldProps {
    keyPrefix: string
    value?: string
    required?: boolean
    error?: string
    seleniumLocation?: string
    className?: string
    onChangeText(value: string): void
}

export const TaskTextField: FC<TaskTextFieldProps> = ({
    keyPrefix,
    value,
    required,
    error,
    seleniumLocation,
    className,
    onChangeText,
}) => {
    const { t } = useTranslation()

    return (
        <TaskFormField
            className={className}
            label={translateParts(t)(keyPrefix, 'label')}
            required={required}
            error={error}
            seleniumLocation={seleniumLocation}
        >
            <Input
                className='w-full'
                variant={error ? 'error' : value ? 'filled' : 'not-filled'}
                value={value ?? ''}
                placeholder={translatePartsOptional(t)(keyPrefix, 'placeholder')}
                onChangeText={onChangeText}
            />
        </TaskFormField>
    )
}
